import './App.scss';

import Tie from './components/Tie';
import Sidebar from './components/Sidebar';
import Main from './components/Main';

const App = () => {
  return (
    <div className="app">
      <Tie/>
      <Main/>
      <Sidebar/>
    </div>
  );
}

export default App;
